import React from 'react';
import UserParlaysContainer from "../UserParlaysContainer/UserParlaysContainer";
import {useSelector} from "react-redux";
import {selectUserParlaysInLastThirtyDays} from "../../stores/pickX/pickX.selectors";
import './MyLast30Days.style.scss';
import {useGetUserParlaysHistoryQuery} from "../../stores/pickX/pickX.api";
import moment from "moment";

const _30DaysAgo = moment().add(-30, 'days').toDate().toISOString()

const MyLast30Days = () => {

    const last30DaysUserParlays = useSelector(selectUserParlaysInLastThirtyDays);
    const {isLoading} = useGetUserParlaysHistoryQuery(_30DaysAgo);



    return (
        <div className="MyLast30Days">
            <UserParlaysContainer userParlays={last30DaysUserParlays}/>
        </div>
    );
}

export default MyLast30Days;